__turbopack_context__.v({
  "gradientOverlayLeft": "ImageOverlay-module__NP-kpG__gradientOverlayLeft",
  "gradientOverlayRight": "ImageOverlay-module__NP-kpG__gradientOverlayRight",
});
